module.exports = __webpack_public_path__ + "static/img/Human-performance-analysis-icon-1.51c85f8b.svg";